import { AssetType, NodeType, Service } from "@zapier/canvas-state";
import { ASSET_APP_IDS } from "@zapier/canvas-constants";

export function determineAssetType(
  selectedApps: Service[] | undefined,
  nodeType: NodeType,
): AssetType {
  if (nodeType === "zap") {
    return "zap";
  }

  const appId = selectedApps?.[0]?.currentImplementation.id ?? "";
  const isTablesNode = appId.includes(ASSET_APP_IDS.TABLES);
  const isInterfacesNode = appId.includes(ASSET_APP_IDS.INTERFACES);
  const isChatbotsNode = appId.includes(ASSET_APP_IDS.CHATBOTS);

  if (isTablesNode) {
    return "table";
  }

  if (isInterfacesNode) {
    return "interface";
  }

  if (isChatbotsNode) {
    return "chatbot";
  }

  return undefined;
}
